import { useEffect, useSyncExternalStore } from 'react';
import { MobileGamepadState, gamepadStore } from './store';
import type { PlaycastGamepadState } from '@playcastdotio/CoreTypes';

export const mobileGamepadToGamepadStateMessage = (gamepad: MobileGamepadState): PlaycastGamepadState => {
  return {
    playerCoordinates: {
      origin: 'topLeft',
      dimensions: {
        x: 0,
        y: 0,
      },
      display: {
        x: 0,
        y: 0,
      },
    },
    gamepads: [
      {
        deviceId: 1000,
        timestamp: Date.now(),
        id: 'Playcast Mobile Gamepad',
        xInput: {
          wButtons: gamepad.wButtons,
          bLeftTrigger: gamepad.bLeftTrigger,
          bRightTrigger: gamepad.bRightTrigger,
          sThumbLX: gamepad.sThumbLX,
          sThumbLY: gamepad.sThumbLY,
          sThumbRX: gamepad.sThumbRX,
          sThumbRY: gamepad.sThumbRY,
        },
      },
    ],
  };
};

interface MobileGamepadMessagingProps {
  callback?: (gamepadState: PlaycastGamepadState) => void;
}

export const MobileGamepadMessaging = (props: MobileGamepadMessagingProps) => {
  const { callback } = props;
  const gamepad = useSyncExternalStore(gamepadStore.subscribeGamepad, gamepadStore.getGamepad);

  useEffect(() => {
    if (gamepad) {
      const gamepadState: PlaycastGamepadState = mobileGamepadToGamepadStateMessage(gamepad);
      if (callback) {
        callback(gamepadState);
      } else {
        console.log('gamepadState', gamepadState);
      }
    }
  }, [gamepad, callback]);

  return null;
};
